import { ca } from '@cian/analytics';

export function filterChange(filter: string, value: string) {
  ca('event', {
    action: `${filter}_tab_click`,
    category: `${window.__mainpage_section__}_page`,
    label: value,
    name: 'oldevent',
  });
}

export function checkboxClick(value: string) {
  ca('event', {
    action: 'Categor_select',
    category: `${window.__mainpage_section__}_page`,
    label: value,
    name: 'filterevent',
  });
}
